import './PreviewFab.css';
import { Fab } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PreviewStatus from 'Components/PreviewStatus/PreviewStatus';
import { useProfile } from 'context/ProfileContext';
import { isReadableOnDark } from 'utils';
import { BRAND_LEFT } from 'utils/constants';
import { STATUS } from 'utils/enums';

interface PreviewFabProps {
    onClick: () => void;
    hidden?: boolean;
}

const PreviewFab = ({ onClick, hidden = false }: PreviewFabProps) => {
    const { state, pending } = useProfile();
    const { t } = useTranslation();
    const [profileStatus, setProfileStatus] = useState<STATUS>(STATUS.DEFAULT);

    useEffect(() => {
        if (state.isPublished) {
            if (JSON.stringify(state.lastProfile) !== JSON.stringify(state.currentProfile)) {
                setProfileStatus(STATUS.DRAFT);
            } else {
                setProfileStatus(STATUS.PUBLISHED);
            }
        } else {
            setProfileStatus(STATUS.NOT_PUBLISHED);
        }
    }, [state]);

    const userColor =
        (state.currentProfile.theme?.background as { gradient?: { left?: string } } | undefined)?.gradient?.left
        ?? BRAND_LEFT;

    // Only honor the user's color if it's bright enough to be visible on the
    // FAB's dark glass background. When too dark, the CSS fallback to
    // --draft-color (semantic blue) kicks in.
    const fabStyle = isReadableOnDark(userColor)
        ? { ['--preview-fab-user-color' as string]: userColor }
        : undefined;

    return (
        <Fab
            variant="extended"
            onClick={onClick}
            className={`preview-fab${hidden ? ' is-hidden' : ''}`}
            aria-label={t('profile.preview.fab.aria-label')}
            style={fabStyle}
        >
            <PreviewStatus
                pending={pending}
                publishDate={state.publishDate}
                profileStatus={profileStatus}
                t={t}
            />
        </Fab>
    );
};

export default PreviewFab;
